function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import CustomerQuotes, { CUSTOMER_KEY_OSCAR, CUSTOMER_KEY_THE_STUDENT_HOTEL, CUSTOMER_KEY_TELEFONICA, CUSTOMER_KEY_NISSAN, CUSTOMER_KEY_ZIPPO } from "constants/customer-quotes";
export default {
    autoplay: {
        shouldAutoPlay: true,
        interval: "10000"
    },
    reviews: [
        _object_spread_props(_object_spread({}, CustomerQuotes[CUSTOMER_KEY_OSCAR]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/oscar_image.png",
                alt: "Oscar's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/oscar_logo.svg",
                alt: "Oscar logo"
            }
        }),
        _object_spread_props(_object_spread({}, CustomerQuotes[CUSTOMER_KEY_THE_STUDENT_HOTEL]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/the_student_hotel_image.png",
                alt: "The Student Hotel's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/the_student_hotel_logo.svg",
                alt: "The Student Hotel logo"
            }
        }),
        _object_spread_props(_object_spread({}, CustomerQuotes[CUSTOMER_KEY_TELEFONICA]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/telefonica_image.png",
                alt: "Telefonica's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/telefonica_logo.svg",
                alt: "Telefonica logo"
            }
        }),
        _object_spread_props(_object_spread({}, CustomerQuotes[CUSTOMER_KEY_ZIPPO]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/zippo_image.png",
                alt: "Zippo's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/zippo.svg",
                alt: "Zippo logo"
            }
        }),
        _object_spread_props(_object_spread({}, CustomerQuotes[CUSTOMER_KEY_NISSAN]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/nissan_image.png",
                alt: "Nissan's customer image"
            },
            companyLogo: {}
        })
    ]
};
